import React from 'react'
import { Modal, Button, Icon, Input, Table } from 'antd';
import isEqual from 'lodash/isEqual';
import './style/index.less';

const Search = Input.Search;
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'cs-browser'
  }
  constructor(props) {
    super(props);
    this.state = {
      datas: props.datas || [],
      valueSpan: '',
      value: '',
      visible: false,
      count: 0,
      current: 1,
      search: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { datas } = this.props;
    let nState = null;
    if (nextProps.datas && !isEqual(nextProps.datas, datas)) {
      nState = { datas: nextProps.datas };
    }
    nState && this.setState(nState);
  }

  onCancel = () => {
    this.setState({ visible: false });
  }

  onSearch = () => {

  }

  setSearchValue = (val) => {
  }

  render() {
    const { prefixCls } = this.props;
    const { value, valueSpan, visible, datas, count, current, search } = this.state;
    const columns = [
      { title: '客户名称', dataIndex: 'name', key: 'name', },
      { title: '客户经理', dataIndex: 'username', key: 'username', },
    ];
    return (
      <div className={prefixCls}>
        <Input value={valueSpan} onChange={() => null} addonAfter={<Icon type="search" onClick={() => this.setState({ visible: true })} />} />
        <Modal
          title="客户"
          className={`${prefixCls}-Modal`}
          visible={visible}
          onCancel={this.onCancel}
          maskClosable={false}
          width={700}
          footer={[
            <Button key="cusCancel" onClick={this.onCancel}>返回</Button>
          ]}
        >
          <div className={`${prefixCls}-cusModal-search`}>
            <Search value={search} onChange={(e) => this.setSearchValue(e.target.value)} onSearch={this.onSearch} />
          </div>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={datas}
            size="middle"
            pagination={{
              total: count,
              current: current,
              // onChange: this.onPageChange,
            }}
            // onRow={this.onRow}
          />
        </Modal>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/public/cs-browser/index.js